import type { PasswordRuleResult } from "@/lib/password-policy";
import { PasswordRuleLabel } from "./PasswordRuleLabel";

export function PasswordRuleList({ rules }: { rules: PasswordRuleResult[] }) {
	return (
		<ul
			data-testid="password-rules"
			style={{
				margin: 0,
				padding: 0,
				listStyle: "none",
				display: "flex",
				flexDirection: "column",
				gap: 4,
			}}
		>
			{rules.map((rule) => (
				<li
					key={rule.label}
					data-satisfied={rule.satisfied}
					style={{
						display: "flex",
						alignItems: "baseline",
						gap: 8,
						fontSize: "var(--text-caption)",
						lineHeight: "var(--leading-ui)",
						color: rule.satisfied ? "var(--fg-1)" : "var(--fg-2)",
					}}
				>
					<span
						style={{
							flexShrink: 0,
							width: 8,
							height: 8,
							borderRadius: "var(--radius-full)",
							background: rule.satisfied ? "var(--success)" : "var(--danger)",
							transition: "background-color 150ms ease",
							transform: "translateY(-1px)",
						}}
					/>
					<PasswordRuleLabel label={rule.label} characters={rule.characters} />
				</li>
			))}
		</ul>
	);
}
